"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCountries = void 0;
var locale_1 = require("./locale");
var SUPPORTED_LOCALES = {
    Hints: [
        'cs_CZ',
        'da_DK',
        'de_AT',
        'de_BE',
        'de_CH',
        'de_DE',
        'de_LI',
        'de_LU',
        'en_CA',
        'en_GB',
        'en_GB',
        'en_IE',
        'en_LT',
        'en_US',
        'es_ES',
        'fi_FI',
        'fr_BE',
        'fr_CA',
        'fr_CH',
        'fr_FR',
        'fr_LU',
        'hu_HU',
        'it_CH',
        'nl_BE',
        'nl_NL',
        'no_NO',
        'pl_PL',
        'sk_SK',
        'sv_SE',
    ],
    EventPortal: [
        'cs_CZ',
        'da_DK',
        'de_AT',
        'de_BE',
        'de_CH',
        'de_DE',
        'de_LI',
        'de_LU',
        'en_CA',
        'en_GB',
        'en_GB',
        'en_IE',
        'en_LT',
        'en_US',
        'es_ES',
        'fi_FI',
        'fr_BE',
        'fr_CA',
        'fr_CH',
        'fr_FR',
        'fr_LU',
        'hu_HU',
        'it_CH',
        'nl_BE',
        'nl_NL',
        'no_NO',
        'pl_PL',
        'sk_SK',
        'sv_SE',
    ],
    MarketingSite: [
        'cs_CZ',
        'da_DK',
        'de_AT',
        'de_CH',
        'de_DE',
        'de_LI',
        'en_AT',
        'en_BE',
        'en_BR',
        'en_CA',
        'en_CH',
        'en_CZ',
        'en_DE',
        'en_DK',
        'en_ES',
        'en_FI',
        'en_FR',
        'en_GB',
        'en_HU',
        'en_IE',
        'en_IT',
        'en_LI',
        'en_LT',
        'en_LU',
        'en_MY',
        'en_NL',
        'en_NO',
        'en_PL',
        'en_RO',
        'en_RS',
        'en_SE',
        'en_SK',
        'en_TW',
        'en_US',
        'en_ZA',
        'es_ES',
        'es_US',
        'fi_FI',
        'fr_BE',
        'fr_CA',
        'fr_CH',
        'fr_FR',
        'fr_LU',
        'hu_HU',
        'it_CH',
        'it_IT',
        'lt_LT',
        'my_MY',
        'nl_BE',
        'nl_NL',
        'no_NO',
        'pl_PL',
        'pt_BR',
        'ro_RO',
        'sk_SK',
        'sr_RS',
        'sv_SE',
        'zh_TW',
    ],
    PartnerLibrary: [
        'cs_CZ',
        'da_DK',
        'de_AT',
        'de_CH',
        'de_DE',
        'de_LI',
        'en_AT',
        'en_BE',
        'en_BR',
        'en_CA',
        'en_CH',
        'en_CZ',
        'en_DE',
        'en_DK',
        'en_ES',
        'en_FI',
        'en_FR',
        'en_GB',
        'en_HU',
        'en_IE',
        'en_IT',
        'en_LI',
        'en_LT',
        'en_LU',
        'en_MY',
        'en_NL',
        'en_NO',
        'en_PL',
        'en_RO',
        'en_RS',
        'en_SE',
        'en_SK',
        'en_TW',
        'en_US',
        'en_ZA',
        'es_ES',
        'es_US',
        'fi_FI',
        'fr_BE',
        'fr_CA',
        'fr_CH',
        'fr_FR',
        'fr_LU',
        'hu_HU',
        'it_CH',
        'it_IT',
        'lt_LT',
        'my_MY',
        'nl_BE',
        'nl_NL',
        'no_NO',
        'pl_PL',
        'pt_BR',
        'ro_RO',
        'sk_SK',
        'sr_RS',
        'sv_SE',
        'zh_TW',
    ],
    LegalTexts: [
        'cs_CZ',
        'da_DK',
        'de_AT',
        'de_BE',
        'de_CH',
        'de_DE',
        'de_LI',
        'de_LU',
        'en_AT',
        'en_BE',
        'en_BR',
        'en_CA',
        'en_CH',
        'en_CZ',
        'en_DE',
        'en_DK',
        'en_ES',
        'en_FI',
        'en_FR',
        'en_GB',
        'en_HU',
        'en_IE',
        'en_IT',
        'en_LI',
        'en_LT',
        'en_LU',
        'en_MY',
        'en_NL',
        'en_NO',
        'en_PL',
        'en_RO',
        'en_RS',
        'en_SE',
        'en_SK',
        'en_TW',
        'en_US',
        'en_ZA',
        'es_ES',
        'es_US',
        'fi_FI',
        'fr_BE',
        'fr_CA',
        'fr_CH',
        'fr_FR',
        'fr_LU',
        'hu_HU',
        'it_CH',
        'it_IT',
        'lt_LT',
        'my_MY',
        'nl_BE',
        'nl_NL',
        'no_NO',
        'pl_PL',
        'pt_BR',
        'ro_RO',
        'sk_SK',
        'sr_RS',
        'sv_SE',
        'zh_TW',
    ],
};
var getSupportedLocales = function (platform) {
    return SUPPORTED_LOCALES[platform];
};
var getSupportedCountries = function (platform) {
    var supportedLocales = getSupportedLocales(platform);
    var supportedCountryCodes = supportedLocales.map(function (locale) { return locale.substring(3); });
    return Object.entries(locale_1.allCountries)
        .filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], country = _b[1];
        return supportedCountryCodes.includes(country.countryCode);
    })
        .reduce(function (acc, _a) {
        var _b;
        var _c, _d, _e;
        var _f = __read(_a, 2), countryKey = _f[0], country = _f[1];
        var supportedLanguages = supportedLocales
            .filter(function (locale) { return locale.substring(3) === country.countryCode; })
            .map(function (locale) { return locale.substring(0, 2); });
        var filteredLanguages = (_e = (_d = (((_c = country.languages) !== null && _c !== void 0 ? _c : []))) === null || _d === void 0 ? void 0 : _d.filter(function (language) {
            return supportedLanguages.includes(language.languageCode);
        })) !== null && _e !== void 0 ? _e : [];
        var supportedCountry = __assign(__assign({}, country), { languages: filteredLanguages });
        return __assign(__assign({}, acc), (_b = {}, _b[countryKey] = supportedCountry, _b));
    }, {});
};
exports.getSupportedCountries = getSupportedCountries;
